import { audioPlayerInit } from './audio-gallery';
import { initOnlineMasteringQuotesGallery } from './quotes-gallery';
import { initOnlineMasteringVideoGallery } from './video-gallery';
import { initOnlineMasteringPricing } from './pricing';
import { initYotpoStars } from './yotpo-stars';
import { initTooltips } from './tooltips/tooltips-provider';

const initSeePricingBtn = () => {
    const $btn = document.getElementById('see-pricing-btn');
    if(!$btn) return;

    $btn.addEventListener('click', evt => {
        evt.preventDefault();

        const $pricingSection = document.getElementById('pricing');
        if(!$pricingSection) return;

        $pricingSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    });
};

const init = () => {

    // audio gallery at the top
    // written by Vlad, used also in Voice Regen place
    // this is a wrapper around the main slider used, for example, in the footer
    audioPlayerInit();

    initOnlineMasteringQuotesGallery();
    initYotpoStars();
    initOnlineMasteringVideoGallery();
    initOnlineMasteringPricing();

    initSeePricingBtn();
    initTooltips();
};

/**
 * entry point
 */
document.addEventListener('DOMContentLoaded', () => {
    init();
});

export {};

